import React, { useCallback } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSessionContext } from 'modules/session';
import { useNotesBackgroudTimerContext } from 'modules/NotesBackgroudTimer/context/NotesBackgroudTimerContext';
import { useFeatureFlag } from 'modules/common/hooks';
import { AppMenuItemProps } from '../AppMenuItemProps';
import { ReactComponent as LogoutIcon } from '../icons/logout.svg';

interface LogoutMenuItemProps extends AppMenuItemProps {
  onMenuClose: () => void;
  openLogoutDialog: () => void;
}

export const LogoutMenuItem = ({
  classes,
  onMenuClose,
  openLogoutDialog
}: LogoutMenuItemProps): JSX.Element => {
  const { logout } = useSessionContext();
  const { running } = useNotesBackgroudTimerContext();
  const isTiwInlineTimerEnabled = useFeatureFlag('isTiwInlineTimerEnabled');

  const handleLogout = useCallback(() => {
    if (isTiwInlineTimerEnabled && running) {
      openLogoutDialog();
      onMenuClose();
      return;
    }
    logout();
    onMenuClose();
  }, [logout, onMenuClose, openLogoutDialog, running, isTiwInlineTimerEnabled]);

  return (
    <MenuItem
      onClick={handleLogout}
      data-testid="logout-menu"
      className={classes.menuItem}
    >
      <ListItemIcon className={classes.icon}>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="appMenu.logout" />
      </ListItemText>
    </MenuItem>
  );
};
